/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import styles from "../styles/authStyles.module.css";
import React, { useEffect, useState } from "react";
import WelcomeTitle from "../components/WelcomeTitle";
import InputField from "../components/InputField";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../api/auth";
import { authSelector, getLoggedUser } from "../../redux/slices/authSlice";
import LoginCarousel from "./LoginCarousel";
import { LockOutlined } from "@mui/icons-material";
import { FaCreativeCommonsSa } from "react-icons/fa";
import useWindowWidth from "../../hooks/useWindowWidth";
import { isClientPreview } from "../../utils/clientPreview";
import SignInPreview from "./SignInPreview";

export default function NewSignIn() {
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleValues = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedUser } = useSelector(authSelector);

  const preview = isClientPreview();

  const handleLogin = () =>
    dispatch(login(values)).then(({ payload }) => {
      if (payload?.user) {
        const userRole = payload.user.role;

        if (userRole === "admin") {
          navigate("/admin/dashboard");
        } else if (userRole === "customer") {
          navigate("/customer/dashboard");
        }
      }
    });

  // const expirationTime = loggedUser?.tokens?.access?.expires;
  // const isTokenExpired = expirationTime
  //   ? Date.now() > new Date(expirationTime).getTime()
  //   : true;

  const localLoggedUser = JSON.parse(localStorage.getItem("loggedUser"));

  // Navigate to the appropriate dashboard based on user role
  useEffect(() => {
    const navigateBasedOnRole = () => {
      if (localLoggedUser?.user?.role) {
        const userRole = localLoggedUser?.user?.role || loggedUser?.user?.role;

        if (userRole === "admin") {
          navigate("/admin/dashboard");
        } else if (userRole === "customer") {
          navigate("/customer/dashboard");
        }
      }
    };

    navigateBasedOnRole();
  }, [navigate, dispatch, localLoggedUser]);

  const isEmpty = Object.keys(values).filter((key) => values[key] === "");

  useEffect(() => {
    // The preview form submits on Enter by itself.
    if (preview) return undefined;
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && isEmpty.length === 0) {
        handleLogin();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [dispatch, values, isEmpty]);

  const windowWidth = useWindowWidth();

  if (preview) {
    return <SignInPreview values={values} onChange={handleValues} onSubmit={handleLogin} />;
  }

  return (
    <div style={{ background: "white" }}>
      <Grid container>
        <Grid item xs={windowWidth >= 932 ? 6 : 12} sx={{ height: "100vh" }}>
          <div
            style={{ height: "100vh", display: "grid", placeItems: "center" }}
          >
            <div
              style={{
                width: windowWidth <= 932 ? "60%" : "50%",
                margin: "auto",
              }}
            >
              <WelcomeTitle
                title="Welcome Back!"
                subTitle="Stay on top of your business."
              />
              <div className={styles.form}>
                <InputField
                  label="@ Email"
                  placeholder="Type your email "
                  type="text"
                  size="small"
                  name="email"
                  onChange={handleValues}
                />
                <InputField
                  label={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <LockOutlined
                        style={{ fontSize: "15px", marginRight: "2px" }}
                      />{" "}
                      <span>Password</span>
                    </div>
                  }
                  placeholder="Enter your password"
                  type="password"
                  size="small"
                  name="password"
                  onChange={handleValues}
                />

                <div style={{ textAlign: "right" }}>
                  <Link to="/forgot-password" style={{ color: "#975bff" }}>
                    Forgot Password?
                  </Link>
                </div>

                <div className={styles.button_part}>
                  <Button
                    variant="lightblue"
                    className="w-full"
                    sx={{
                      margin: "10px auto",
                      background: "#412471",
                      boxShadow: "none",
                      "&:hover": {
                        background: "#412495",
                      },
                    }}
                    onClick={handleLogin}
                    disabled={isEmpty.length !== 0}
                  >
                    Login
                  </Button>
                  {/* <h6 style={{ fontSize: "16px", marginTop: "10px" }}>
                    Don't have an account?
                    <Link to="/signup">
                      <span style={{ fontWeight: 600, color: "#975bff" }}>
                        {" "}
                        Sign Up
                      </span>
                    </Link>
                  </h6> */}
                  <div
                    style={{
                      border: "1px solid lightgray",
                      padding: "5px 20px",
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"center",
                      borderRadius:"8px",
                      cursor:'pointer'
                    }}
                    onClick={() => {
                      // window.location.href="https://admin.shopify.com/"
                      window.location.href="https://apps.shopify.com/u-send"
                    
                    }}
                  >
                    <img
                      src="https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png"
                      alt="logo"
                      style={{
                        maxWidth: "30px",
                        height: "30px",
                        // marginLeft: sidebarExpand ? "-25px" : "0",
                        marginRight: "10px",
                        objectFit: "contain",
                      }}
                    />
                    Register with shopify
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        {windowWidth >= 932 && (
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "linear-gradient(54deg, rgba(24,9,47,1) 0%, rgba(43,14,92,1) 100%)",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "80%",
                width: "68%",
                margin: "auto",
                borderRadius: "25px",
                background:
                  "linear-gradient(54deg, rgba(65,35,112,1) 0%, rgba(79,35,153,1) 100%)",
                padding: "40px 20px",
              }}
            >
              <LoginCarousel />
              <div
                style={{
                  position: "absolute",
                  width: "66%",
                  margin: "auto",
                  textAlign: "center",
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent:
                      windowWidth <= 1450 ? "center" : "space-evenly",
                    color: "lightgray",
                    alignItems: "center",
                    flexDirection: windowWidth <= 1450 ? "column" : "row",
                  }}
                >
                  <h6
                    style={{
                      fontSize: windowWidth <= 1450 ? "12px" : "14px",
                      display: "flex",
                      alignItems: "center",
                      lineHeight: 1,
                      marginBottom: windowWidth <= 1450 ? 0 : "20px",
                      marginRight: "10px",
                    }}
                  >
                    <FaCreativeCommonsSa
                      style={{ transform: "ScaleX(-1)", marginRight: "5px" }}
                    />{" "}
                    <a
                      href="https://u-sendfulfillment.com/"
                      style={{ color: "lightgray", fontWeight: 300 }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      2024 - All rights reserved U-Send
                    </a>
                  </h6>
                  <h6
                    style={{
                      fontSize: "14px",
                      lineHeight: 1,
                      marginTop: windowWidth <= 1450 ? "0px" : "20px",
                    }}
                  >
                    <a
                      style={{ color: "lightgray", fontWeight: 300 }}
                      href="/help/privacy"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    -{" "}
                    <a
                      style={{ color: "lightgray", fontWeight: 300 }}
                      href="/help/terms-and-conditions"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms of Service
                    </a>
                  </h6>
                </div>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
